import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineProListPage } from '@/feature/hotline/professional/list/page/HotlineProListPage';
/**
 * 匿名コンサルホットライン 相談一覧
 * @description api データ取得を伴わないアクセス制限等を行う
 */
export const HotlineProList = () => _jsx(HotlineProListPage, {});
